import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getOrders,
  getOrderById,
} from "../services/orderDetails.service";

/* ------------------ Fetch Order List ------------------ */
export const fetchOrderHistory = createAsyncThunk(
  "orders/fetchOrderHistory",
  async (filters = {}, { rejectWithValue }) => {
    try {
      return await getOrders(filters);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

/* ------------------ Fetch Single Order ------------------ */
export const fetchOrderById = createAsyncThunk(
  "orders/fetchOrderById",
  async (orderNo, { rejectWithValue }) => {
    try {
      return await getOrderById(orderNo);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

const orderDetailSlice = createSlice({
  name: "orders",
  initialState: {
    // List page
    results: [],
    pagination: {},

    // Detail page
    order: null,

    loading: false,
    error: null,
  },
  reducers: {
    clearOrdersState: (state) => {
      state.results = [];
      state.pagination = {};
      state.order = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ------------------ LIST ------------------ */
      .addCase(fetchOrderHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload?.order_header || [];
        state.pagination = {
          total: action.payload?.total || 0,
          current_page: action.payload?.current_page || 1,
          limit: action.payload?.limit || 10,
        };
      })
      .addCase(fetchOrderHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ------------------ DETAIL ------------------ */
      .addCase(fetchOrderById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.loading = false;
        state.order = action.payload;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearOrdersState } = orderDetailSlice.actions;
export default orderDetailSlice.reducer;
